import AboutBlacklistButton from "./about-blacklist-button";
export default AboutBlacklistButton;
